<template>
  <div>
    <v-divider class="my-4"></v-divider>
    <p class="text-lg gradient-label font-bold text-gray-700">
      Template Message Triggers
    </p>
    <div class="grid grid-cols-2 gap-4">
      <div
        v-for="category in templateTriggerCategories"
        :key="category.title"
        class="border shadow-sm border-gray-300 border-solid p-3"
      >
        <p class="mb-0 gradient-label">{{ category.title }}</p>
        <v-divider class="my-4"></v-divider>
        <div
          v-for="(trigger) in category.triggers"
          :key="trigger.type"
          class="flex items-center justify-between mt-4"
        >
          <p class="flex-grow text-sm text-gray-700 mb-0">
            <span class="font-bold"> {{ trigger.title }} </span>
            <span v-if="trigger.subTitle" class="text-gray-700">
              - ({{ trigger.subTitle }})
            </span>
          </p>
          <div class="w-52">
            <SelectComponent
              showAddNew
              @add="onAddTemplateTrigger(category, trigger)"
              @select="
                (selected) => handleTemplateChange(trigger, category, selected)
              "
              :items="availableTriggerTemplates[category.category] || []"
              v-model="trigger.template"
              itemText="name"
              itemValue="name"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectComponent from "@/components/UI/Select.vue";

const templateTriggerCategories = [
  {
    title: "Task triggers",
    category: "task",
    triggers: [
      { title: "Assign", type: "task_assign", template: null },
      {
        title: "End",
        type: "task_end_agent",
        template: null,
        subTitle: "agent",
      },
      {
        title: "End",
        type: "task_end_customer",
        template: null,
        subTitle: "customer",
      },
    ],
  },
  {
    title: "Notification triggers",
    category: "notification",
    triggers: [{ title: "AMC", type: "amc_notification", template: null }],
  },
  {
    title: "Tele-caller triggers",
    category: "tele-caller",
    triggers: [
      {
        title: "Call End",
        type: "tele_caller_notification_agent",
        template: null,
        subTitle: "agent",
      },
      {
        title: "Call End",
        type: "tele_caller_notification_customer",
        template: null,
        subTitle: "customer",
      },
    ],
  },
];

export default {
  name: "TemplateTriggers",
  components: { SelectComponent },
  props: {
    availableTemplates: {
      type: Array,
      default: () => [],
    },
    templateTriggers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      templateTriggerCategories,
    };
  },
  watch: {
    templateTriggers: {
      handler(newVal) {
        this.templateTriggerCategories =
          this.getTemplateTriggerCategories(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    availableTriggerTemplates() {
      const templates = this.availableTemplates.reduce((prev, curr) => {
        if (prev[curr.triggerCategory]) {
          prev[curr.triggerCategory].push(curr);
        } else {
          prev[curr.triggerCategory] = [curr];
        }

        return prev;
      }, {});

      return templates;
    },
  },
  methods: {
    handleTemplateChange(trigger, category, { value, item }) {
      this.$emit("triggerChange", {
        trigger,
        category,
        template: { ...item, name: value },
      });
    },
    onAddTemplateTrigger(category, trigger) {
      this.$emit("addTemplateTrigger", { category, trigger });
    },
    // onAddTemplate(trigger, category) {
    //   this.$emit("onAddTemplate", trigger);
    // },
    getTemplateTriggerCategories(templateTriggers) {
      return templateTriggerCategories.map((category) => {
        const triggers = category.triggers.map((trigger) => {
          const t = templateTriggers.find((t) => t.type === trigger.type);
          return { ...trigger, template: t?.template || "" };
        });

        return { ...category, triggers };
      });
    },
  },
};
</script>

<style></style>
